import { toUpper, get as _get } from 'lodash';

import React, { useEffect, useState, useRef } from 'react';
import Checkbox from '../abs-filter-components/filters/CheckboxAbs';
import FilterValueLabel from '../abs-filter-components/filters/FilterValueLabelAbs';
import PriceFilter from '../collection-filters/PriceFilter';
const CollectionFilter = ({
  index,
  activeFilterIndex,
  filterType,
  updateValueToFilters,
  appliedFilters,
  isFilterCollapsed,
  handleFilterCollapse,
  filterTypeProducts,
  SetapplyFilterCheck,
}) => {
  const [isChecked, SetIsChecked] = useState(false);
  let classNames = 'abs-collection-filter-card';

  const ORDER = [
    '10',
    '11',
    '12',
    '13',
    '14',
    '15',
    '16',
    '17',
    '18',
    '19',
    '20',
    'one size',
    'xxs',
    'xs',
    's',
    'm',
    'l',
    'xl',
    'xxl',
    '2xl',
    '3xl',
    '4xl',
  ];
  const productVendorfi = [filterTypeProducts[1]];
  const productTypefi = [filterTypeProducts[0]];
  //console.log(productVendorfi,productTypefi,'productTypefiproductTypefi')

  const [selectedVenType, setSelectedVenType] = useState(false);
  const [productVenedUpdate, setproductVenedUpdate] = useState([]);

  const handleSelect = vendortypeinfo => {
    const isPresentVen = productVendorfi[0].find(
      each => each === vendortypeinfo
    );
    // alert(isPresentVen === vendortypeinfo)
    if (isPresentVen === vendortypeinfo) {
      // setSelectedVenType(true);
      productVenedUpdate.push(isPresentVen);
    } else {
      // setSelectedVenType(false);
    }
  };

  // this function help to re-rwrite a attribute lables
  const rewriteCollectionName = _get(
    window,
    'compatioConfig.shopify.collectionHandle'
  )
    ? _get(window, 'window.compatioConfig.shopify.collectionHandle')
    : [];
  const rewriteCollectionFilter = _get(
    window,
    'compatioConfig.rewriteCollectionFilter'
  )
    ? _get(window, 'compatioConfig.rewriteCollectionFilter')
    : [];
  if (rewriteCollectionFilter !== undefined) {
    rewriteCollectionFilter.map(element => {
      if (rewriteCollectionName === element.Collection) {
        if (element.Current === filterType.name) {
          filterType.switch = element.switch;
        }
      } else {
        if (element.Collection === 'customized') {
          // console.log(element, filterType);
          if (element.Current === filterType.name) {
            filterType.switch = element.switch;
          }
        }
      }
      // console.log(element.Updated.toLowerCase(),filterType.name.toLowerCase(),rewriteCollectionName.toLowerCase())
      if (
        element.Current === filterType.name &&
        rewriteCollectionName == element.Collection &&
        element.Updated !== undefined
      ) {
        filterType.name = element.Updated;
      } else {
        if (element.Collection === 'customized') {
          // console.log(element)
          if (element.Current === filterType.name) {
            // console.log(element)
            filterType.name = element.Updated;
          }
        }
      }
    });
  }

  useEffect(() => {
    const gst = filterType.values.map(f => f);
    // console.log(gst.map(f=>f),'filterType')
    const isPresent =
      appliedFilters &&
      appliedFilters.find(each => {
        return (
          each.name === filterType.attr &&
          each.value === filterType.values.map(e => e.value)
        );
      });
    // debugger;
    if (isPresent) {
      // SetIsChecked(false);
      SetIsChecked(true);
    } else {
      // SetIsChecked(true);
    }

    // console.log(appliedFilters.map(element => element),'element',filterType)
  }, [appliedFilters]);
  // console.log(
  //   filterType.values.length,
  //   rewriteCollectionName.includes('women')
  // );

  if (
    filterType.name !== 'Manufacturer' &&
    filterType.name !== 'Price Filter' &&
    filterType.name !== 'Size' &&
    filterType.name !== 'Gender' &&
    filterType.switch !== false
  ) {
    // console.log(filterType, 'filterType');
    return (
      <>
        <div
          className={
            isFilterCollapsed === false && activeFilterIndex == index
              ? `${classNames} active`
              : classNames
          }
          id={filterType.attr}
        >
          <label
            className={
              isChecked
                ? 'active-nav abs-collection-filter-name'
                : 'abs-collection-filter-name'
            }
            onClick={() => handleFilterCollapse(index, filterType.attr)}
          >
            {filterType.name == 'Manufacture'
              ? 'Manufacturer'
              : filterType.name}
            <span>
              <i
                className={
                  activeFilterIndex != index ? 'arrow down' : 'arrow up'
                }
              ></i>
            </span>
          </label>

          <div
            className={
              !isFilterCollapsed && activeFilterIndex === index
                ? 'showvalue abs-collection-filter-values'
                : 'hidevalue abs-collection-filter-values'
            }
          >
            {!isFilterCollapsed && activeFilterIndex === index ? (
              parseInt(filterType.valuesPerRow) == 1 ? (
                filterType.values
                  .map(filterValue => {
                    // console.log(filterValue,'filterValue',filterValue.meta.display_value === 'None' ? filterValue.value : filterValue.meta.display_value)
                    let displayNameText =
                      filterValue.meta.display_value === 'None'
                        ? filterValue.value
                        : filterValue.meta.display_value;
                    // console.log(displayNameText)
                    return (
                      <label
                        className="abs-filter-singlevalue"
                        key={filterValue.value}
                      >
                        <Checkbox
                          name={filterValue.value}
                          updateValueToFilters={updateValueToFilters}
                          filterType={filterType}
                          filterValue={filterValue}
                          appliedFilters={appliedFilters}
                          SetapplyFilterCheck={SetapplyFilterCheck}
                        />
                        <div>
                          {toUpper(
                            // displayNameText
                            //   ? displayNameText
                            //   : filterValue.value
                            filterValue.value
                          )}{' '}
                          {filterValue.count != undefined
                            ? `(${filterValue.count})`
                            : null}
                        </div>
                      </label>
                    );
                  })
                  .sort((a, b) => a.key - b.key)
              ) : (
                <div className="abs-filter-label-box">
                  {filterType.values.map(filterValue => {
                    return (
                      <FilterValueLabel
                        key={filterValue.metaValue}
                        filterType={filterType}
                        filterValue={filterValue}
                        updateValueToFilters={updateValueToFilters}
                        isApplied={filterValue.checked}
                        appliedFilters={appliedFilters}
                      />
                    );
                  })}
                </div>
              )
            ) : null}
          </div>
        </div>
      </>
    );
  } else if (
    filterType.name === 'Price Filter' &&
    filterType.switch !== false
  ) {
    return (
      <>
        {/* <div
          className={
            isFilterCollapsed === false && activeFilterIndex == index
              ? `${classNames} active`
              : classNames
          }
          id={filterType.attr}
        >
          <label
            className={
              isChecked
                ? 'active-nav abs-collection-filter-name'
                : 'abs-collection-filter-name'
            }
            onClick={() => handleFilterCollapse(index, filterType.attr)}
          >
            {filterType.name == 'Manufacture'
              ? 'Manufacturer'
              : filterType.name}
            <span>
              <i
                className={
                  activeFilterIndex != index ? 'arrow down' : 'arrow up'
                }
              ></i>
            </span>
          </label>

          <div
            className={
              !isFilterCollapsed && activeFilterIndex === index
                ? 'showvalue abs-collection-filter-values pricefilters'
                : 'hidevalue abs-collection-filter-values'
            }
          >
            <PriceFilter
              filterType={filterType}
              updateValueToFilters={updateValueToFilters}
              appliedFilters={appliedFilters}
            />
          </div>
        </div> */}
      </>
    );
  } else if (filterType.name === 'Size' && filterType.switch !== false) {
    return (
      <>
        <div
          className={
            isFilterCollapsed === false && activeFilterIndex == index
              ? `${classNames} active`
              : classNames
          }
          id={filterType.attr}
        >
          <label
            className={
              isChecked
                ? 'active-nav abs-collection-filter-name'
                : 'abs-collection-filter-name'
            }
            onClick={() => handleFilterCollapse(index, filterType.attr)}
          >
            {filterType.name == 'Manufacture'
              ? 'Manufacturer'
              : filterType.name}
            <span>
              <i
                className={
                  activeFilterIndex != index ? 'arrow down' : 'arrow up'
                }
              ></i>
            </span>
          </label>

          <div
            className={
              !isFilterCollapsed && activeFilterIndex === index
                ? 'showvalue abs-collection-filter-values'
                : 'hidevalue abs-collection-filter-values'
            }
          >
            {!isFilterCollapsed && activeFilterIndex === index ? (
              parseInt(filterType.valuesPerRow) == 1 ? (
                filterType.values
                  .map(filterValue => {
                    let displayNameText =
                      filterValue.meta.display_value === 'None'
                        ? filterValue.value
                        : filterValue.meta.display_value;
                    return (
                      <label
                        className="abs-filter-singlevalue"
                        key={filterValue.value}
                      >
                        <Checkbox
                          name={filterValue.value}
                          updateValueToFilters={updateValueToFilters}
                          filterType={filterType}
                          filterValue={filterValue}
                          appliedFilters={appliedFilters}
                          SetapplyFilterCheck={SetapplyFilterCheck}
                        />
                        <div>
                          {toUpper(
                            displayNameText
                              ? displayNameText
                              : filterValue.value
                          )}{' '}
                          {filterValue.count != undefined
                            ? `(${filterValue.count})`
                            : null}
                        </div>
                      </label>
                    );
                  })
                  .sort((a, b) => {
                    // console.log(a.key, b.key);
                    a = a.key.toLowerCase();
                    b = b.key.toLowerCase();
                    let nra = parseInt(a);
                    let nrb = parseInt(b);

                    if (ORDER.indexOf(a) != -1) nra = NaN;
                    if (ORDER.indexOf(b) != -1) nrb = NaN;

                    if (nrb === 0) return 1;
                    if ((nra && !nrb) || nra === 0) return -1;
                    if (!nra && nrb) return 1;
                    if (nra && nrb) {
                      if (nra == nrb) {
                        return a
                          .substr(('' + nra).length)
                          .localeCompare(a.substr(('' + nra).length));
                      } else {
                        return nra - nrb;
                      }
                    } else {
                      return ORDER.indexOf(a) - ORDER.indexOf(b);
                    }
                  })
              ) : (
                // .sort((a, b) => a.key - b.key)
                // .sort((a, b) => a.key - b.key)
                <div className="abs-filter-label-box">
                  {filterType.values.map(filterValue => {
                    return (
                      <FilterValueLabel
                        key={filterValue.metaValue}
                        filterType={filterType}
                        filterValue={filterValue}
                        updateValueToFilters={updateValueToFilters}
                        isApplied={filterValue.checked}
                        appliedFilters={appliedFilters}
                      />
                    );
                  })}
                </div>
              )
            ) : null}
          </div>
        </div>
      </>
    );
  } else if (
    filterType.name === 'Gender' &&
    filterType.switch !== false &&
    filterType.values.length > 1 &&
    // !rewriteCollectionName.includes('women')
    !/women|men/.test(rewriteCollectionName)
  ) {
    return (
      <>
        <div
          className={
            isFilterCollapsed === false && activeFilterIndex == index
              ? `${classNames} active`
              : classNames
          }
          id={filterType.attr}
        >
          <label
            className={
              isChecked
                ? 'active-nav abs-collection-filter-name'
                : 'abs-collection-filter-name'
            }
            onClick={() => handleFilterCollapse(index, filterType.attr)}
          >
            {filterType.name == 'Manufacture'
              ? 'Manufacturer'
              : filterType.name}
            <span>
              <i
                className={
                  activeFilterIndex != index ? 'arrow down' : 'arrow up'
                }
              ></i>
            </span>
          </label>

          <div
            className={
              !isFilterCollapsed && activeFilterIndex === index
                ? 'showvalue abs-collection-filter-values'
                : 'hidevalue abs-collection-filter-values'
            }
          >
            {!isFilterCollapsed && activeFilterIndex === index ? (
              parseInt(filterType.valuesPerRow) == 1 ? (
                filterType.values
                  .map(filterValue => {
                    let displayNameText =
                      filterValue.meta.display_value === 'None'
                        ? filterValue.value
                        : filterValue.meta.display_value;
                    return (
                      <label
                        className="abs-filter-singlevalue"
                        key={filterValue.value}
                      >
                        <Checkbox
                          name={filterValue.value}
                          updateValueToFilters={updateValueToFilters}
                          filterType={filterType}
                          filterValue={filterValue}
                          appliedFilters={appliedFilters}
                          SetapplyFilterCheck={SetapplyFilterCheck}
                        />
                        <div>
                          {toUpper(
                            displayNameText
                              ? displayNameText
                              : filterValue.value
                          )}{' '}
                          {filterValue.count != undefined
                            ? `(${filterValue.count})`
                            : null}
                        </div>
                      </label>
                    );
                  })
                  .sort((a, b) => a.key - b.key)
              ) : (
                <div className="abs-filter-label-box">
                  {filterType.values.map(filterValue => {
                    return (
                      <FilterValueLabel
                        key={filterValue.metaValue}
                        filterType={filterType}
                        filterValue={filterValue}
                        updateValueToFilters={updateValueToFilters}
                        isApplied={filterValue.checked}
                        appliedFilters={appliedFilters}
                      />
                    );
                  })}
                </div>
              )
            ) : null}
          </div>
        </div>
      </>
    );
  } else {
    return <></>;
  }
};

export default CollectionFilter;
